import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import {isWeiXin, GetQueryString, ToLogin} from '../utils/utils'
import Cookies from 'js-cookie'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((recode) => recode.meta.noAuth)) {
    next()
  } else {
    if (isWeiXin()) {
      // 是否在微信打开
      const token = Cookies.get('token')
      // const token = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJQYW5lbCIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL3NpZCI6Ijc5MjU2NDY1NzQ5MjAxOTIiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2V4cGlyYXRpb24iOiIzLzMwLzIzIDM6MTM6MDcgUE0iLCJuYmYiOjE2ODAwNzM5ODcsImV4cCI6MTY4MDEwOTk4NywiaXNzIjoicGZnLml0IiwiYXVkIjoiUGZnIn0.sps75IVP-qbMD-H0bmxMaOGy1xogX4yVPcUi3QyKBPw`
      Cookies.set('token', token, {expires: 1})
      let code = GetQueryString('code')
      if (token) {
        next()
      } else if (code) {
        let data = await $api.getLoginAuth(code)
        console.log('是否授权页data', data)
        if (data) {
          window.localStorage.setItem('userInfo', JSON.stringify(data))
          Cookies.set('token', data.token, {expires: 1})
          console.log('设置了token', data.token)
          let url = window.localStorage.getItem('toUrl')
          window.localStorage.removeItem('toUrl')
          window.location.href = url
        }
      } else {
        ToLogin()
      }
    } else {
      next({
        path: '/error',
        query: {
          errorMsg: '请在微信打开该链接',
        },
      })
    }
  }
  // next()
  // console.log(to.path)
})

export default router
